import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { EcoMasterData, EcoMasterRequest } from "@tmhcc-ng-lib/data-service";
import { AllowedRoute } from "./shared/page-header/page-header-navigation/page-header-navigation-def";
import { Observable, Subject } from "rxjs";
import { LoaderService } from "@tmhcc-ng-lib/framwork/loader";

@Injectable()
export class PreloadMasterDataGuard  {
  allowNavigation$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private ecoMasterData: EcoMasterData,
    private router: Router,
    private loader: LoaderService
  ) {}

  payload: EcoMasterRequest = {
    SubCompanyCode: "ECO"
  };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.loader.show();
    this.ecoMasterData.fetchMasterDataAsync(this.payload).subscribe(
      () => {
        this.loader.hide();
        return this.allowNavigation$.next(true);
      },
      () => {
        this.loader.hide();
        return this.allowNavigation$.next(false);
      }
    );
    return this.allowNavigation$;
  }
}
